/* ============================================================================
   AB · water-ripple on the Add-to-Cart buttons (Marian 2026-06-26).
   On press, concentric soft rings ripple out from the click point like a drop
   of water. Delegated + passive; does not touch the button's own click/submit.
   Honors reduced-motion. Styling lives in ab-v2-brand.css (.ab-ripple).
   ============================================================================ */
(function () {
  if (window.__abAtcRipple) return;
  window.__abAtcRipple = true;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Every FILLED add-to-cart button (text-link adds like the upsell/box are skipped).
  // NOTE: .jho-cta (hero "Pflege entdecken") removed 2026-06-28 - it is a nav button,
  // the ripple read as the button "expanding" with a circle on tap.
  var SEL = '.jpd-cta, .jpd-stickybuy__cta, .jcl-card__action, ' +
            '.jrt-btn--add, .jsd-quickview__add, .jpb-add';

  document.addEventListener('pointerdown', function (e) {
    var btn = e.target.closest ? e.target.closest(SEL) : null;
    if (!btn) return;

    var rect = btn.getBoundingClientRect();
    if (!rect.width) return;
    var x = e.clientX - rect.left;
    var y = e.clientY - rect.top;
    // reach the far corner so the ring always clears the button
    var dx = Math.max(x, rect.width - x);
    var dy = Math.max(y, rect.height - y);
    var size = Math.sqrt(dx * dx + dy * dy) * 2.1;

    btn.classList.add('ab-ripple-host');

    // two staggered rings = a water-drop feel
    for (var i = 0; i < 2; i++) {
      (function (i) {
        var r = document.createElement('span');
        r.className = 'ab-ripple';
        r.style.left = x + 'px';
        r.style.top = y + 'px';
        r.style.setProperty('--ab-ripple-size', size + 'px');
        r.style.animationDelay = (i * 130) + 'ms';
        btn.appendChild(r);
        var kill = function () { if (r.parentNode) r.parentNode.removeChild(r); };
        r.addEventListener('animationend', kill);
        setTimeout(kill, 1400);
      })(i);
    }
  }, { passive: true });
})();
